const imageService = {
  generateImage (url: string, onReady?: (image: HTMLImageElement) => void) {
    const image = new window.Image()
    image.onload = (event) => {
      if (event.currentTarget && onReady) {
        onReady(event.currentTarget as HTMLImageElement)
      }
    }
    image.src = url
    if (!onReady) return image
  }
}

export default imageService
